const Spinner = ({ color = 'primary' }) => {
  return (
    <div className={`spinner-grow spinner-grow-sm text-${color}`} role='status'>
      <span className='visually-hidden'>Loading...</span>
    </div>
  );
};

export default Spinner;
